export default {
	
	validations: {
		required: "Il valore è obbligatorio.",
		undefined: "Il valore è obbligatorio.",
		email: "Il valore non è un indirizzo email valido",
		minLength: "Questo campo dovrebbe essere lungo almeno ${min} caratteri",
		maxLength: "La lunghezza massima consentita è ${max}",
		minValue: "Il valore minimo consentito è ${min}",
		maxValue: "Il valore massimo consentito è ${max}",
		numeric: "Il valore deve essere numerico",
		ipAddress: "Il valore non è un indirizzo IP valido",
		sameAs: "Il valore deve essere uguale al valore ${otherName}",
	}
}